<template>
  <div>
    <v-flex xs12 sm12 md12>
      <v-container fill-height fluid>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <bank-batch-list />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import BankBatchList from "../../components/uniqueBilling/BankBatchListUsinas.vue";
export default {
  components: {
    BankBatchList,
  },
};
</script>
<style scoped></style>
